<div>
  <input
    #timeInput
    type="text"
    class="w-[86px] text-center outline-none"
    placeHolderCharacter=" "
    [formControl]="displayedTimeFormControl"
    (keydown)="timeInputKeyDown($event)"
    (click)="openTimePicker()"
    (focus)="selectTimeInput()"
    (beforeinput)="timeInputTransform($event, displayedTimeFormControl)"
    (paste)="timeInputPaste($event, displayedTimeFormControl)"
    (blur)="timeInputBlur($event, displayedTimeFormControl)"
  />
  <div #menuTrigger [matMenuTriggerFor]="menu"></div>
  <mat-menu
    #menu
    class="bd-menu inline-editor-time-picker with-theme"
    [hasBackdrop]="false"
    [xPosition]="'before'"
  >
    <ng-template matMenuContent>
      @let timeProposalArray = (timeProposalArray$ | async) ?? [];
      <blaze-scroller>
        @if (timeProposalArray.length) {
          @for (timeProposal of timeProposalArray; track timeProposal) {
            <button
              class="min-w-[86px]"
              [class.selected]="displayedTimeFormControl.value === timeProposal"
              mat-menu-item
              [value]="timeProposal"
              (click)="patchTimeProposal(timeProposal); closeTimePicker()"
            >
              {{ timeProposal }}
            </button>
          }
        } @else {
          @for (timeProposal of proposedValuesFromInput; track timeProposal) {
            <button
              mat-menu-item
              class="min-w-[86px]"
              (click)="patchTimeProposal(timeProposal); closeTimePicker()"
            >
              {{ timeProposal }}
            </button>
          }
        }
      </blaze-scroller>
    </ng-template>
  </mat-menu>
</div>
